import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["companion", "trigger"]
  static values = { expanded: Boolean }

  connect() {
    if (this.expandedValue) this.expand()
  }

  expand() {
    this.panel = this.element.closest('[data-drawer-target="panel"]')
    this.wrapper = this.panel?.querySelector('[data-drawer-target="innerWrapper"]')
    if (this.panel && !this.originalWidth) {
      this.originalWidth = this.panel.style.width
      this.originalWrapperWidth = this.wrapper?.style.width
    }
    if (this.panel) this.panel.style.width = "min(100vw, calc(var(--drawer-width) * 2))"
    if (this.wrapper) this.wrapper.style.width = "100%"
    this.element.classList.add("drawer-columns-expanded")
    this.companionTarget.hidden = false
    this.triggerTargets.forEach(button => button.setAttribute("aria-expanded", "true"))
    this.companionTarget.querySelector("button")?.focus()
  }

  collapse(event) {
    if (this.companionTarget.hidden) return
    event?.stopPropagation()
    this.restore()
    this.element.classList.remove("drawer-columns-expanded")
    this.companionTarget.hidden = true
    this.triggerTargets.forEach(button => button.setAttribute("aria-expanded", "false"))
    this.triggerTargets[0]?.focus()
  }

  restore() {
    if (this.panel && this.originalWidth) this.panel.style.width = this.originalWidth
    if (this.wrapper && this.originalWrapperWidth) this.wrapper.style.width = this.originalWrapperWidth
  }

  disconnect() { this.restore() }
}
